import { NgModule } from '@angular/core';
import { ResultsModule } from '../../results/results.module';
import { BasePreviewComponent } from './components/base-preview/base-preview.component';
import { CodePreviewComponent } from './components/code-preview/code-preview.component';
import { ErrorPreviewComponent } from './components/error-preview/error-preview.component';
import { FilePreviewPopupComponent } from './components/file-preview-popup/file-preview-popup.component';
import { ImagePreviewComponent } from './components/image-preview/image-preview.component';
import { MdPreviewComponent } from './components/md-preview/md-preview.component';
import { MediaPreviewComponent } from './components/media-preview/media-preview.component';
import { OnlinePreviewComponent } from './components/online-preview/online-preview.component';
import { PdfPreviewComponent } from './components/pdf-preview/pdf-preview.component';
import { TextPreviewComponent } from './components/text-preview/text-preview.component';
import { FilePreviewContainerComponent } from './file-preview-container/file-preview-container.component';
import { FilePreviewComponent } from './file-preview.component';
import { FilePreviewService } from './services/file-preview.service';

const components = [
  BasePreviewComponent,
  CodePreviewComponent,
  ErrorPreviewComponent,
  FilePreviewComponent,
  FilePreviewContainerComponent,
  FilePreviewPopupComponent,
  ImagePreviewComponent,
  MdPreviewComponent,
  MediaPreviewComponent,
  OnlinePreviewComponent,
  PdfPreviewComponent,
  TextPreviewComponent,
];

@NgModule({
  declarations: components,
  imports: [ResultsModule],
  providers: [FilePreviewService],
  exports: components,
})
export class FilePreviewModule {}
